import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IAbUseExperiment } from '../../types/experiments';

const initialState: IAbUseExperiment[] = [];

export const experimentsSlice = createSlice({
  name: 'experiments',
  initialState,
  reducers: {
    setExperiments: (_state, action: PayloadAction<IAbUseExperiment[]>) => {
      return action.payload;
    },
  },
});

export const { setExperiments } = experimentsSlice.actions;
